import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "nv_access_token";

export function setAccessToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
}
export function clearAccessToken() {
  localStorage.removeItem(TOKEN_KEY);
}
export function getAccessToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

// Authenticated calls — sends httpOnly cookies AND Authorization Bearer header.
// The Bearer header is critical for mobile Safari / iOS where Intelligent
// Tracking Prevention may block third-party cookies, causing 401s on subsequent
// API calls after a successful login.
export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public calls — used for unauthenticated endpoints (e.g. POST /leads).
// Credentials must NOT be sent here, otherwise the browser rejects the
// response because the platform ingress returns `Access-Control-Allow-Origin: *`
// which is incompatible with `Allow-Credentials: true`.
export const publicApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: false,
});

export function formatCHF(amount) {
  if (amount === null || amount === undefined) return "—";
  return new Intl.NumberFormat("de-CH", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Unbekannter Fehler";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  if (d.msg) return d.msg;
  return String(d);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("de-CH", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export const PAYMENT_STATUS_LABELS = {
  open: "Offen",
  paid: "Bezahlt",
  late: "Verspätet",
  checked: "Geprüft",
  released: "Freigegeben",
  cancelled: "Storniert",
};

export const PAYMENT_METHOD_LABELS = {
  cash: "Bar",
  twint: "TWINT",
  bank: "Banküberweisung",
};

export const ROLE_LABELS = {
  participant: "Teilnehmer",
  admin: "Administrator",
  controller: "Controlling",
};
